import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    relative: {
      position: 'relative',
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(2),
    },
    stepper: {
      '& .MuiStepIcon-active': {
        color: '#64a7b5',
      },
      '& .MuiStepIcon-completed': {
        color: '#1a7992',
      },
    },
    closeButton: {
      position: 'absolute',
      right: 0,
      zIndex: 1000,
    },
    mainTitle: {
      textTransform: 'uppercase',
      textAlign: 'center',
      color: '#1a7992',
    },
    // buttonsWrapper: {
    //   display: 'flex',
    //   alignItems: 'center',
    //   justifyContent: 'center',
    //   columnGap: theme.spacing(2),
    // },
  };
});
